export const pxmModbusConstants = {
    PXM_MODBUS_LIST_REQUEST: "PXM_MODBUS_LIST_REQUEST",
    PXM_MODBUS_LIST_SUCCESS: "PXM_MODBUS_LIST_SUCCESS",
    PXM_MODBUS_LIST_FAILURE: "PXM_MODBUS_LIST_FAILURE",

    PXM_MODBUS_BY_ID_REQUEST: "PXM_MODBUS_BY_ID_REQUEST",
    PXM_MODBUS_BY_ID_SUCCESS: "PXM_MODBUS_BY_ID_SUCCESS",
    PXM_MODBUS_BY_ID_FAILURE: "PXM_MODBUS_BY_ID_FAILURE",

    CREATE_SCENE_SUCCESS: "CREATE_SCENE_SUCCESS",
    CREATE_SCENE_FAILURE: "CREATE_SCENE_FAILURE",

    UPDATE_SCENE_SUCCESS: "UPDATE_SCENE_SUCCESS",
    UPDATE_SCENE_FAILURE: "UPDATE_SCENE_FAILURE",

    DELETE_SCENE_SUCCESS: "DELETE_SCENE_SUCCESS",
    DELETE_SCENE_FAILURE: "DELETE_SCENE_FAILURE",

}
